import classNames from 'classnames'
import Link from 'next/link'
import { z } from 'zod'

import { topicPageCategorySchema } from '@/lib/zodSchemas/articlePageSchema'

type Props = {
  category: z.infer<typeof topicPageCategorySchema>
  selected: string | null | undefined
}

export function CategorySidebarNav({ category, selected }: Props) {
  return (
    <aside className="sticky w-72 px-8 top-0 h-full hidden md:block pt-8">
      <ul>
        {category.categories?.filter(c => c.slug !== 'policy-landscape').map((c) => (
          <li key={c.slug}
            className={classNames('mb-3 hover:text-green-500 transition-colors', {
              'active-item': c.slug === selected,
            })}
          >
            <Link
              className={classNames({
                'active-item font-semibold': c.slug === selected,
              })}
              href={`/${c.slug}`}
            >
              {c.title}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  )
}
